import { useQuery } from 'react-query';
import type { QueryOptions } from 'react-query';

import type {
  FunnelSummary,
  PayoutSummary,
  PerformanceSummaryQueryWithProductType,
} from '@portal/api-models';

import { client } from '../client';
import { QueryKey } from '../types';

export const getPayoutSummary = (
  params: PerformanceSummaryQueryWithProductType
) =>
  client
    .get<PayoutSummary[]>(
      `/analytics/performanceSummaries/${params.productType}/payout`,
      { params }
    )
    .then(({ data }) => data);

export const getFunnelSummary = (
  params: PerformanceSummaryQueryWithProductType
) =>
  client
    .get<FunnelSummary[]>(
      `/analytics/performanceSummaries/${params.productType}/funnel`,
      { params }
    )
    .then(({ data }) => data);

export const useGetPayoutSummaryQuery = (
  params: PerformanceSummaryQueryWithProductType,
  options?: QueryOptions<PayoutSummary[]>
) =>
  useQuery(
    [QueryKey.PerformanceSummaryPayout, params],
    () => getPayoutSummary(params),
    options
  );

export const useGetFunnelSummaryQuery = (
  params: PerformanceSummaryQueryWithProductType,
  options?: QueryOptions<FunnelSummary[]>
) =>
  useQuery(
    [QueryKey.PerformanceSummaryFunnel, params],
    () => getFunnelSummary(params),
    options
  );
